import { Component, Inject } from '@angular/core';

@Component({
    selector: 'reports-menu-drop-down',
    template: require('./reports-menu-drop-down.component.html')
})
export class ReportsMenuDropDownComponent {
    constructor(@Inject('$state') private $state: any) {
    }

    public navigate(event: any, sref: any) {
        event.preventDefault();
        this.$state.go(sref);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/reports-menu-drop-down/reports-menu-drop-down.component.ts